var arrayLikeToArray = require("./arrayLikeToArray");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;


//////////////////
// WEBPACK FOOTER
// ./~/jss-plugin-vendor-prefixer/~/css-vendor/~/@babel/runtime/helpers/arrayWithoutHoles.js
// module id = 1658
// module chunks = 0